export const SET_RESEND_OTP_ACTION = 'SET_RESEND_OTP_ACTION';
export const SET_RESEND_OTP_SUCCESS_ACTION = 'SET_RESEND_OTP_SUCCESS_ACTION';
export const SET_RESEND_OTP_FAILURE_ACTION = 'SET_RESEND_OTP_FAILURE_ACTION';
